import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {isValidFunction} from '../utils';

function MountingWrapper({children, onShow, onHide}) {
	useEffect(() => {
		isValidFunction(onShow) && onShow();

		return () => {
			isValidFunction(onHide) && onHide();
		};
	}, []);

	return <React.Fragment>{children}</React.Fragment>;
}

MountingWrapper.propTypes = {
	onShow: PropTypes.func,
	onHide: PropTypes.func
};

export default MountingWrapper;
